// Version-sets modal — single window with two tabs:
//   - PUBLISH LOG : timeline of every version set in this project
//   - DELETED      : grouped trash where users restore or permanently
//                    delete sheets
//
// Replaces the older standalone DELETED + PUBLISH LOG header buttons. Both
// `PublishLog` and `DeletedSheets` are now body-only components — this
// modal supplies the backdrop, header, tabs, and close button.

import React, { useState } from 'react';
import { useStore } from '../store/useStore';
import PublishLog from './PublishLog';
import DeletedSheets from './DeletedSheets';
import styles from './VersionSetsModal.module.css';

const TABS = [
  { id: 'publish', label: 'Publish log' },
  { id: 'deleted', label: 'Deleted' },
];

export default function VersionSetsModal() {
  const { versionSetsModalOpen, setVersionSetsModalOpen, versionSetsModalTab, setVersionSetsModalTab } = useStore();
  const [localTab, setLocalTab] = useState('publish');

  // Allow callers to deep-link a tab via the store (e.g. a "Trash" affordance
  // elsewhere can open straight to the Deleted tab). Falls back to local
  // state when no caller has set a preference.
  const activeTab = versionSetsModalTab || localTab;
  function pickTab(id) {
    if (versionSetsModalTab) setVersionSetsModalTab(id);
    setLocalTab(id);
  }

  if (!versionSetsModalOpen) return null;

  function close() {
    setVersionSetsModalOpen(false);
    if (setVersionSetsModalTab) setVersionSetsModalTab(null);
  }

  return (
    <div
      className={styles.backdrop}
      onClick={(e) => e.target === e.currentTarget && close()}
    >
      <div className={styles.modal}>
        <div className={styles.header}>
          <span className={styles.title}>VERSION SETS</span>
          <div className={styles.tabs}>
            {TABS.map((t) => (
              <button
                key={t.id}
                type="button"
                className={`${styles.tab} ${activeTab === t.id ? styles.tabActive : ''}`}
                onClick={() => pickTab(t.id)}
              >
                {t.label}
              </button>
            ))}
          </div>
          <button className={styles.closeBtn} onClick={close} aria-label="Close">×</button>
        </div>

        <div className={styles.body}>
          {activeTab === 'publish' ? <PublishLog /> : <DeletedSheets />}
        </div>
      </div>
    </div>
  );
}
